import BaseApi from './BaseApi.js';

/**
 * 問い合わせ用APIクライアント
 */
export default class InquiryApi extends BaseApi {
  /**
   * 新しいInquiryApiインスタンスを作成
   */
  constructor() {
    super('/api/inquiry');
  }

  /**
   * 問い合わせを送信
   * @param {Object} data 問い合わせデータ
   * @param {string} data.name 氏名
   * @param {string} data.phone 電話番号（必須）
   * @param {string} data.address 住所
   * @param {string} data.email メールアドレス（必須）
   * @param {string} data.message 問い合わせ内容
   * @param {number} data.firmId 事務所ID
   * @return {Promise<object>} APIレスポンス
   */
  async send(data) {
    return this.client.post('/send', data);
  }
}
